import { Component } from '@angular/core';

@Component({
	selector    : 'app',
	templateUrl : 'app.html',
	styleUrls   : [ 'app.scss' ]
})

export class AppComponent {}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/app/app.ts